import { render } from "./ChangePassword.vue?vue&type=template&id=40c7ca9a&scoped=true&ts=true"
import script from "./ChangePassword.vue?vue&type=script&lang=ts"
export * from "./ChangePassword.vue?vue&type=script&lang=ts"

import "./ChangePassword.vue?vue&type=style&index=0&id=40c7ca9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c7ca9a"]])

export default __exports__